import { callApi } from './utils';
import { trackEvent } from '../../lib/analytics';

export const FETCH_FLAG_SUCCESS = 'FETCH_FLAG_SUCCESS';
export const FETCH_ALL_FLAGS_SUCCESS = 'FETCH_ALL_FLAGS_SUCCESS';
export const SET_FLAG_SUCCESS = 'SET_FLAG_SUCCESS';
export const DESTROY_FLAG_SUCCESS = 'DESTROY_FLAG_SUCCESS';
export const CREATE_FLAG_SUCCESS = 'CREATE_FLAG_SUCCESS';

const getFlag = name => async dispatch => {
  const response = await fetch(`/feature_flags/${name}`);
  const data = await response.json();

  return dispatch({
    type: FETCH_FLAG_SUCCESS,
    data,
  });
};

const getAllFlags = name => async dispatch => {
  const response = await fetch(`/admins/feature_flags`);
  const data = await response.json();

  return dispatch({
    type: FETCH_ALL_FLAGS_SUCCESS,
    data
  });
};

const setFlag = (name, enabled) => async dispatch => {
  const response = await callApi(`/admins/feature_flags/${name}`, 'PATCH', { enabled });
  const data = await response.json();

  return dispatch({
    type: SET_FLAG_SUCCESS,
    data
  });
};

const destroyFlag = name => async dispatch => {
  const response = await callApi(`/admins/feature_flags/${name}`, 'DELETE');
  const id = await response.json();

  return dispatch({
    type: DESTROY_FLAG_SUCCESS,
    id,
  });
};

const createFlag = attrs => async dispatch => {
  const response = await callApi('/admins/feature_flags', 'POST', attrs);
  const data = await response.json();

  return dispatch({
    type: CREATE_FLAG_SUCCESS,
    data,
  });
};

export default {
  getFlag,
  getAllFlags,
  setFlag,
  destroyFlag,
  createFlag,
};
